import { IToastConfig } from 'src/common/primitives/Toast';

export function generateEditSuccessToast(id: number): IToastConfig {
  return {
    id,
    title: `Assignment updated successfully`,
  };
}
